<section class="reportes container py-4">
  <h2>Reportes y Analíticas</h2>

  <div class="row mb-3">
    <div class="col-12">
      <div class="d-flex flex-wrap align-items-end filters-row">
        <div class="form-group mb-2">
          <label class="d-block">Desde</label>
          <input type="date" class="form-control" [(ngModel)]="periodoDesde">
        </div>

        <div class="form-group mb-2">
          <label class="d-block">Hasta</label>
          <input type="date" class="form-control" [(ngModel)]="periodoHasta">
        </div>

        <div class="form-group mb-2">
          <label class="d-block">Región</label>
          <select class="form-control" [(ngModel)]="filtroRegion">
            <option value="">-- Todas --</option>
            <option>Metropolitana</option>
            <option>Valparaíso</option>
            <option>Biobío</option>
          </select>
        </div>

        <div class="form-group mb-2">
          <label class="d-block">COMPIN</label>
          <input class="form-control" [(ngModel)]="filtroCompin" placeholder="COMPIN">
        </div>

        <div class="form-group mb-2">
          <label class="d-block">Institución</label>
          <input class="form-control" [(ngModel)]="filtroInstitucion" placeholder="Nombre institución">
        </div>

        <div class="form-group mb-2">
          <label class="d-block d-md-none">&nbsp;</label>
          <button class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
        </div>

        <div class="w-100 d-flex justify-content-md-end mb-0">
          <div class="btn-group export-actions" role="group" aria-label="exports">
            <button class="btn btn-outline-secondary btn-sm mr-2" (click)="exportCSV()">Exportar CSV</button>
            <button class="btn btn-outline-secondary btn-sm mr-2" (click)="exportExcel()">Exportar Excel</button>
            <button class="btn btn-outline-secondary btn-sm" (click)="exportPDF()">Exportar PDF</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-3">
      <div class="card metric-card">
        <div class="card-body">
          <h6>Casos filtrados</h6>
          <div class="metric-value">{{ filteredCases.length }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card metric-card">
        <div class="card-body">
          <h6>Cumplimiento plazo (%)</h6>
          <div class="metric-value">{{ cumplimientoPorcentaje }}%</div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card metric-card">
        <div class="card-body">
          <h6>Apelaciones (total)</h6>
          <div class="metric-value">{{ apelacionesTotal }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card metric-card">
        <div class="card-body">
          <h6>Apelaciones confirmadas</h6>
          <div class="metric-value">{{ apelacionesConfirmadas }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <h5>Distribución por motivo (Demo)</h5>
      <div class="chart">
        <div *ngFor="let r of topReasons" class="chart-row">
          <div class="chart-label">{{ r.label }}</div>
          <div class="chart-bar"><div class="bar-fill" [style.width.%]="r.pct">{{ r.pct }}%</div></div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <h5>Detalles y tablas</h5>
      <h6>Cantidad por estado</h6>
      <table class="table table-sm mb-3">
        <thead><tr><th>Estado</th><th class="text-right">Cantidad</th></tr></thead>
        <tbody>
          <tr *ngFor="let k of (countsByEstado | keyvalue)">
            <td>{{ k.key }}</td>
            <td class="text-right">{{ k.value }}</td>
          </tr>
        </tbody>
      </table>

      <h6>Tiempos promedio / mediano (días)</h6>
      <table class="table table-sm mb-3">
        <thead><tr><th>Etapa</th><th class="text-right">Promedio</th><th class="text-right">Mediana</th></tr></thead>
        <tbody>
          <tr *ngFor="let k of (avgTimesByEtapa | keyvalue)">
            <td>{{ k.key }}</td>
            <td class="text-right">{{ k.value }}</td>
            <td class="text-right">{{ medianTimesByEtapa[k.key] || '-' }}</td>
          </tr>
        </tbody>
      </table>

      <h6>Casos pendientes &gt; {{ filtroPendientesMasDe }} días por institución</h6>
      <table class="table table-sm">
        <thead><tr><th>Institución</th><th class="text-right">Pendientes</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of pendientesPorEntidad">
            <td>{{ p.entidad }}</td>
            <td class="text-right">{{ p.count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
